/**
 * Hand-written twin of the generated FCM schema's top-level shape, so key-level validation and
 * the provider registry never have to pull the generated artifact into a bundle.
 * `fcm-override.drift.spec.ts` fails if these drift apart.
 *
 * `FCM_ROUTING_KEYS` order is send-plan / claim precedence (see `resolveExclusiveRoutingKeys`).
 * It must also match the routing-key prefix of `Object.keys(fcmOverrideJsonSchema.properties)`.
 */
/**
 * At most one of these may appear in a single FCM content override.
 * Claim / send-plan precedence (sole tie-breaker via `resolveExclusiveRoutingKeys`):
 * token > topic > condition > tokens.
 * Broadcast destinations (topic, condition) beat Novu `tokens` so a same-layer mix keeps the
 * legacy topic path and treats condition the same way.
 */
export const FCM_ROUTING_KEYS = ['token', 'topic', 'condition', 'tokens'];
export const FCM_OVERRIDE_KEYS = [
    ...FCM_ROUTING_KEYS,
    'data',
    'notification',
    'android',
    'webpush',
    'apns',
    'fcmOptions',
];
/** FCM puts the compiled step body into `notification.body`. */
export const FCM_PRIMARY_CONTENT_KEY = 'notification.body';
/** Package subpath the full generated FCM schema ships behind. */
export const FCM_OVERRIDE_SCHEMA_SUBPATH = '@novu/shared/provider-overrides/fcm';
//# sourceMappingURL=keys.js.map